package fr.arcplex.network.model

/**
 * Search contract of the legacy server, expressed on the unified model.
 *
 * A search screen is an ordinary screen whose rail carries an item of type
 * `keyboard`, `numpad` or `keyboard_full`. That item holds the initial query
 * (`content`), the masking flags and `actions.btn_OK.url` with the
 * `#STRRECHERCHE#` marker.
 */

/** Item types that turn a rail into a search input. */
val SEARCH_ITEM_TYPES = setOf("keyboard", "numpad", "keyboard_full")

/** Rail types used by the server for a search input rail. */
val SEARCH_RAIL_TYPES = setOf("KEYBOARD", "NUMPAD", "KEYBOARD_FULL")

/** The keyboard item of this rail, or null when it is not a search rail. */
fun Rail.searchInputItem(): RailItem? =
    items.firstOrNull { it.type.lowercase() in SEARCH_ITEM_TYPES }

/** A rail is rendered as a search field when its type or one of its items says so. */
val Rail.isSearchRail: Boolean
    get() = type.uppercase() in SEARCH_RAIL_TYPES || searchInputItem() != null

/** A screen holding a search input rail. */
val Screen.isSearchScreen: Boolean
    get() = rails.any { it.isSearchRail }

/** Rail ids use `|` on the server but `target_to_refresh` uses `-`. */
fun normalizeRailId(id: String): String = id.replace('|', '-')
